import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMachining = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4 8H12M8 4V12M5.17157 10.8284L10.8284 5.17157M5.17157 5.17157L10.8284 10.8284M2.55556 1H13.4444C14.3036 1 15 1.69645 15 2.55556V13.4444C15 14.3036 14.3036 15 13.4444 15H2.55556C1.69645 15 1 14.3036 1 13.4444V2.55556C1 1.69645 1.69645 1 2.55556 1Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinejoin: "round"
	})
});
export default SvgMachining;
